export const CENTER_TYPES = [
  ['ashram', 'Ashram'],
  ['temple', 'Temple'],
  ['commune', 'Commune'],
  ['center', 'Center'],
];

export const PROGRAM_OPTIONS = [
  'Dynamic Meditation',
  'Kundalini Meditation',
  'Nadabrahma',
  'Retreats',
  'Workshops',
  'Therapy Groups',
];

export const typeLabel = (t) => (CENTER_TYPES.find(([v]) => v === t) || [t, t])[1];

export const DAYS = [
  ['sunday', 'Sunday'],
  ['monday', 'Monday'],
  ['tuesday', 'Tuesday'],
  ['wednesday', 'Wednesday'],
  ['thursday', 'Thursday'],
  ['friday', 'Friday'],
  ['saturday', 'Saturday'],
];

export const defaultHours = () => DAYS.map(([day]) => ({ day, open: '09:00', close: '18:00', closed: false }));

export const dayLabel = (d) => (DAYS.find(([v]) => v === d) || [d, d])[1];
